import { Component, HostBinding, OnDestroy, OnInit } from '@angular/core';
import { AccountConfigService, AuthService } from '@argalis-apps/angular-core';
import { MUser } from '@argalis-apps/models';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-argalis-apps-home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.scss']
})
export class HomePageComponent implements OnInit, OnDestroy {
  @HostBinding('class') themeFlag: string;

  public userConnected: MUser.CUser = null;
  private authServiceSubscriber: Subscription;

  constructor(private authService: AuthService, private accountConfigService: AccountConfigService) {}

  ngOnInit() {
    this.themeFlag = `${this.themeFlag || ''} ${this.accountConfigService.themingClassName}`;
    // this.configService.setOptions({ useTestData: true });
    this.authServiceSubscriber = this.authService.userChange.subscribe((user: MUser.CUser) => {
      if (user && !user.login) this.userConnected = null;
      else this.userConnected = Object.assign({}, user);
    });
  }

  ngOnDestroy() {
    this.authServiceSubscriber.unsubscribe();
  }
}
